(function () {
    'use strict';
    angular.module('Services').service('DifotChartService', DifotChartService);

    DifotChartService.$inject = [
        'Shipments',
        '$filter',
        '$location',
        '$rootScope'
    ];

    function DifotChartService(
        Shipments,
        $filter,
        $location,
        $rootScope
    ) {
        return function (servicesColors) {
            let chartData = {
                config: {
                    mainHeader: 'Difot',
                    subHeader: 'Daily View',
                    height: '27.9em',
                    legendDivId: 'difotChartLegend',
                    viewPath: '/reporting',
                    searchParams: {
                        tab: 'difot-summary'
                    }
                },
                data: ''
            };
            init();

            function init() {
                getDifotChartData();
            }

            function getDifotChartData() {
                let currentDate = new Date();
                let startDate = new Date().setYear(currentDate.getFullYear() - 1);
                let difotChartFilter = {
                    startDate: $filter('date')(startDate, 'yyyy-MM-dd'), //2016-10-31
                    endDate: $filter('date')(currentDate, 'yyyy-MM-dd')
                };
                Shipments.getStatisticsDifot(difotChartFilter, function (result) {
                    const provider = [];
                    const providerObj = {};
                    result = result || [];
                    result.forEach(function (data) {
                        const carrierProfile = angular.getObjVal(data, 'serviceProfile.carrierProfile');
                        if (!carrierProfile) {
                            return;
                        }
                        const difotData = providerObj[carrierProfile.id] || {
                            inTime: {
                                name: carrierProfile.name + " (In Time)",
                                carrierProfileId: carrierProfile.id,
                                carrierProfile: carrierProfile,
                                inTime: true,
                                outOfTime: false,
                                count: 0
                            },
                            outOfTime: {
                                name: carrierProfile.name + " (Out of Time)",
                                carrierProfileId: carrierProfile.id,
                                carrierProfile: carrierProfile,
                                inTime: false,
                                outOfTime: true,
                                count: 0
                            }
                        };
                        difotData.inTime.count += data.inTime;
                        difotData.outOfTime.count += data.outOfTime;
                        providerObj[carrierProfile.id] = difotData;
                    });
                    for (let i in providerObj) {
                        if (providerObj[i].inTime.count > 0) {
                            provider.push(angular.extend(providerObj[i].inTime, {
                                text: "<div style='font-size: 1.2em; line-height: 1.5em; text-align: left; white-space: normal'>" +
                                "<div><b>Carrier Profile: </b> " + providerObj[i].inTime.name + " </div>" +
                                "<div><b>Count: </b>" + providerObj[i].inTime.count + "</div>" +
                                "</div><br/>" +
                                "<span style='color: #444'>Select to view transactions</span>",
                                color: servicesColors.pop() // this is undefined 
                            }));
                        }
                        if (providerObj[i].outOfTime.count > 0) {
                            provider.push(angular.extend(providerObj[i].outOfTime, {
                                text: "<div style='font-size: 1.2em; line-height: 1.5em; text-align: left; white-space: normal'>" +
                                "<div><b>Carrier Profile: </b> " + providerObj[i].outOfTime.name + " </div>" +
                                "<div><b>Count: </b>" + providerObj[i].outOfTime.count + "</div>" +
                                "</div><br/>" +
                                "<span style='color: #444'>Select to view transactions</span>",
                                color: servicesColors.pop()
                            }));
                        }
                    }
                    chartData.data = result && result.length ? configDifotChart(provider) : null;
                });
            }

            function configDifotChart(data) {
                return {
                    "type": "pie",
                    "labelsEnabled": false,
                    "pullOutRadius": '5%',
                    "outlineAlpha": 1,
                    "outlineThickness": 2,
                    "outlineColor": "#ffffff",
                    "dataProvider": data,
                    "valueField": "count",
                    "colorField": "color",
                    "titleField": "name",
                    "balloon": {
                        "fixedPosition": true
                    },
                    "balloonText": "[[text]]",
                    "listeners": [{
                        "event": "clickSlice",
                        "method": function (chart) {
                            let chartFilters = {
                                carrierProfile: chart.dataItem.dataContext.carrierProfile,
                                carrierProfileId: chart.dataItem.dataContext.carrierProfile.id
                            };
                            if (chart.dataItem.dataContext.inTime) {
                                chartFilters.inTime = true;
                            } else {
                                chartFilters.outOfTime = true;
                            }
                            localStorage.setItem('difotChartFilter', angular.toJson(chartFilters));
                            $location.path('/reporting');
                            $rootScope.$apply();
                        }
                    }],
                    "legend": {
                        "enabled": true,
                        "divId": chartData.config.legendDivId,
                        "position": "bottom",
                        "useGraphSettings": false,
                        "equalWidths": true,
                        "spacing": 3,
                        "autoMargins": true,
                        "marginLeft": 20,
                        "marginTop": 0,
                        "markerSize": 13,
                        "fontSize": 10,
                        "labelText": '[[title]]',
                        "valueFunction": function (graphDataItem, valueText) {
                            if (graphDataItem.values) {
                                if (graphDataItem.values.value === 0 || graphDataItem.values.value === undefined) {
                                    valueText = "0"
                                }
                            }
                            return valueText;
                        }
                    },
                    "export": {
                        "enabled": true
                    }
                }
            }

            this.chartData = chartData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/charts/DifotChartService.js